export default "__VITE_ASSET__ZpQ7tk7D__"